/* @flow weak */
import { getText as t } from '@remind/i18n';

export const MONTHS = [
  t('January'),
  t('February'),
  t('March'),
  t('April'),
  t('May'),
  t('June'),
  t('July'),
  t('August'),
  t('September'),
  t('October'),
  t('November'),
  t('December'),
];

export const WEEKDAYS = [
  t('Sunday'),
  t('Monday'),
  t('Tuesday'),
  t('Wednesday'),
  t('Thursday'),
  t('Friday'),
  t('Saturday'),
];

export const WEEKDAYS_COMPACT = [
  t('Su'),
  t('M'),
  t('T'),
  t('W'),
  t('Th'),
  t('F'),
  t('S'),
];

export default {
  MONTHS,
  WEEKDAYS,
  WEEKDAYS_COMPACT,
};



// WEBPACK FOOTER //
// ./src/constants/DateConstants.js